import { gql } from '@apollo/client';

export const getAttachmentUploadUrlMutation = gql`
  mutation GetAttachmentUploadUrlForUser(
    $attachment: GetAttachmentUploadUrlRequest!
  ) {
    getAttachmentUploadUrlForUser(attachment: $attachment) {
      url
      fields
    }
  }
`;

export const extractGetAttachmentUploadUrl = (data) =>
  data.getAttachmentUploadUrlForUser;

export const saveProfilePhotoMutation = gql`
  mutation SaveProfilePhotoForUser($profilePhoto: SaveProfilePhotoInput!) {
    saveProfilePhotoForUser(profilePhoto: $profilePhoto) {
      _id
      desc
      s3Key
      size
      filename
      contentType
      tags
      url
      uploaded
      processed
      profilePhotoFor
      createdBy
      updatedBy
      createdAt
      updatedAt
    }
  }
`;
